











import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ChecksPopup extends Vue {
  @Prop(String) location!: string;

  get checks(): string[] {
    return this.$store.state.tracker_important.foundChecks[this.location];
  }
}
